import { cn } from "@/lib/utils";
import { formatMoney } from "../lib/money";

/** Valor com cor: entradas em verde, saídas em vermelho. */
export function Amount({
  minor,
  currency,
  signed,
}: {
  minor: number;
  currency?: string;
  signed?: "in" | "out";
}) {
  const value = signed === "out" ? -Math.abs(minor) : signed === "in" ? Math.abs(minor) : minor;
  return (
    <span
      className={cn(
        "tabular-nums font-medium",
        value < 0 ? "text-expense" : signed === "in" ? "text-income" : "",
      )}
    >
      {formatMoney(value, currency)}
    </span>
  );
}
